/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */ 
export const CLICK_MODAL_BACKDROP = '[EXPORT] CLICK_MODAL_BACKDROP';
export const FINISH_EXPORT_REQUESTING = '[EXPORT] FINISH_EXPORT_REQUESTING';

export default {
    CLICK_MODAL_BACKDROP,
    FINISH_EXPORT_REQUESTING
}


// WEBPACK FOOTER //
// ./src/view/constant/ExportDataPopupConstant.js